import { matchPath } from 'react-router-dom'

import { SidebarItemsType } from '@/types/sidebar'

import SidebarNavList from './SidebarNavList'
import SidebarNavListItem from './SidebarNavListItem'

type ReduceChildRoutesProps = {
  depth: number
  page: SidebarItemsType
  items: JSX.Element[]
  currentRoute: string
  collapsed?: boolean
}

const reduceChildRoutes = (props: ReduceChildRoutesProps) => {
  const { items, page, depth, currentRoute, collapsed = false } = props

  if (page.children) {
    const open = page.href
      ? !!matchPath(
          {
            path: page.href,
            end: true,
          },
          currentRoute,
        )
      : false
    items.push(
      <SidebarNavListItem
        depth={depth}
        icon={page.icon || (() => null)}
        key={page.title}
        id={page.id}
        badge={page.badge}
        open={!!open}
        title={page.title}
        href={page.href}
        collapsed={collapsed}
      >
        <SidebarNavList
          depth={depth + 1}
          pages={page.children}
          collapsed={collapsed}
        />
      </SidebarNavListItem>,
    )
  } else {
    items.push(
      <SidebarNavListItem
        depth={depth}
        id={page.id}
        href={page.href}
        icon={page.icon || (() => null)}
        key={page.title}
        badge={page.badge}
        title={page.title}
        collapsed={collapsed}
      />,
    )
  }
  return items
}

export default reduceChildRoutes
